import { LocaleIdentifier } from '../types/localeIdentifier'

const locales: Record<string, LocaleIdentifier> = {
  da: 'da_DK',
  de: 'de_DE',
  en: 'en_US',
  fi: 'fi_FI',
  fr: 'fr_FR',
  nl: 'nl_NL',
  sv: 'sv_SE',
}

const DEFAULT_LOCALE = 'en_US'

export const localeCodeToLocaleIdentifier = (code: string | undefined): LocaleIdentifier => {
  if (!code) {
    return DEFAULT_LOCALE
  }

  for (const key in locales) {
    if (code.includes(key)) {
      return locales[key]
    }
  }

  return DEFAULT_LOCALE
}
